import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {Spinner} from 'wix-ui-tpa/cssVars'
import {useLogger} from '../../../../../hooks/logger'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {Interaction} from '../../../../../services/logger'
import cl from '../../../../classnames.scss'
import {classes} from './download-papyrus-tickets.st.css'
import {DownloadPapyrusTicketsProps} from './interfaces'

const DOWNLOAD_RETRY_LIMIT = 10

export const DownloadPapyrusTickets = ({t, className}: DownloadPapyrusTicketsProps) => {
  const {
    downloadTicketsUrl,
    loadingTicketsUrl,
    order: {tickets},
  } = useAppSelector(state => state.placedOrder)
  const {openTicketsDownloadModal, getOrderTicketsDownloadUrl} = useAppActions()
  const {isMobile: mobile} = useEnvironment()
  const logger = useLogger()

  const ticketsCount = tickets?.length ?? 0

  useEffect(() => {
    const init = () => {
      logger.startInteraction(Interaction.LoadingTickets)
      getOrderTicketsDownloadUrl(DOWNLOAD_RETRY_LIMIT)
    }
    init()
  }, [])

  const handleClick = async () => {
    if (downloadTicketsUrl) {
      if (mobile) {
        openTicketsDownloadModal()
      } else {
        window.open(downloadTicketsUrl)
      }
    } else {
      getOrderTicketsDownloadUrl(DOWNLOAD_RETRY_LIMIT)
    }
  }

  return loadingTicketsUrl ? (
    <div className={classes.loaderContainer} data-hook={DH.PREPARING_TICKETS}>
      <Spinner diameter={20} className={classes.spinner} />
      <div className={classNames(cl.formLabelsFont, cl.formLabelsColor)}>
        {t('ticketsThankYou.preparingTickets', {count: ticketsCount})}
      </div>
    </div>
  ) : (
    <button className={className} data-hook={DH.DOWNLOAD_TICKETS} onClick={handleClick}>
      {t('ticketsThankYou.downloadTickets', {count: ticketsCount})}
    </button>
  )
}
